/* unplugin-vue-components disabled */import script from "./function-module.vue?vue&type=script&setup=true&lang=ts"
export * from "./function-module.vue?vue&type=script&setup=true&lang=ts"

import "./function-module.vue?vue&type=style&index=0&id=c76c0b6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c76c0b6e"]])

export default __exports__